import React from 'react'
import Toast from '../../containers/Toast'
import { ToastAction } from '../../reducers/toasts/actionNames'
import { IToast } from './fireToast'

const fireToastSuccess = (
  message: string | React.ReactNode,
  delayClose: number | false = 5000,
  container = 'Main',
  toastId: string | number = undefined,
  withButton = false,
  buttonLabel = '',
  buttonCb: () => void = null,
  buttonIcon: any = null,
): IToast<ToastAction.FireToastSuccess> => ({
  container,
  delayClose,
  message: (
    <Toast.Success
      buttonIcon={buttonIcon}
      withButton={withButton}
      buttonLabel={buttonLabel}
      buttonCb={buttonCb}
    >
      {message}
    </Toast.Success>
  ),
  toastId: toastId ? toastId : (message as string),
  type: ToastAction.FireToastSuccess,
})

export default fireToastSuccess
